/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Group_Language_LabelInputs */



/**
* | output |
* | --- |
* | "Group Language" |
*
* @param {Plain_Text_Import_Group_Language_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_group_language_label = /** @type {((inputs?: Plain_Text_Import_Group_Language_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Group_Language_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue du groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppensprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua di gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Групповой язык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idioma grupal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("群体语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループ言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Idiomas")
	return /** @type {LocalizedString} */ ("Group Language")
});